var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsNumber, IsOptional, IsString, IsUUID } from 'class-validator';
import { PreventionCourseModuleSectionSimpleDto } from './prevention-course-module-section.simple.dto.js';
export class PreventionCourseModuleSimpleDto {
    id;
    title;
    description;
    preventionCourseModuleSections;
    preventionCourseId;
    totalDuration;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PreventionCourseModuleSimpleDto.prototype, "id", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], PreventionCourseModuleSimpleDto.prototype, "title", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], PreventionCourseModuleSimpleDto.prototype, "description", void 0);
__decorate([
    IsArray(),
    Expose(),
    Type(() => PreventionCourseModuleSectionSimpleDto),
    __metadata("design:type", Array)
], PreventionCourseModuleSimpleDto.prototype, "preventionCourseModuleSections", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], PreventionCourseModuleSimpleDto.prototype, "preventionCourseId", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], PreventionCourseModuleSimpleDto.prototype, "totalDuration", void 0);
//# sourceMappingURL=prevention-course-module.simple.dto.js.map